import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import Divider from '@mui/material/Divider/Divider';
import Typography from '@mui/material/Typography/Typography';
import PruefAssistenz from 'src/pages/private/online-antrag/antrag-components/PruefAssistenz';
import {
	checkIfPruefAssitenzNeedsToValidate,
	getProjektLaufzeitBIS_Validation,
	getProjektLaufzeitVON_Validation,
} from 'src/pages/private/online-antrag/application-helper-function/AppHelperfunctions';
import { formStrucProjektdatenPruefassistentGlobal } from 'src/utils/formStruc';
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
import AntragSchema from '../../../../../../../lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

const ProjektDatenAntragEPZ: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	return (
		<>
			<ApplicationHeading title='Projektdaten' description={PLATZHALTER_TEXT} />
			<PruefAssistenz
				statusPath={P.Allgemein_Pruefung_Pruefstatus.path}
				hinweisPath={P.Allgemein_Pruefung_Hinweis_Fuer_Den_Antragsteller.path}
				ueberarbeitetAmPath={P.Allgemein_Pruefung_Ueberarbeitet_Am.path}
				erledigtPath={P.Allgemein_Pruefung_Erledigt.path}
				formStruc={formStrucProjektdatenPruefassistentGlobal(application)}
			/>
			<Grid2 container spacing={6}>
				<Grid2 sm={6}>
					<CreateForm
						formStruc={formStrucSpalte1()}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={updatedReadOnly}
					/>
				</Grid2>
				<Grid2 sm={6}>
					<CreateForm
						formStruc={formStrucSpalte2(application)}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={updatedReadOnly}
					/>
				</Grid2>
			</Grid2>
			<Divider sx={{ mt: 7, mb: 3, borderBottomWidth: 2, borderColor: 'black' }} />
			<Typography variant='h6' sx={{ mb: 3 }}>
				<b>Ergänzender Hinweis zur Projektlaufzeit:</b>
			</Typography>
			<Typography sx={{ mb: 1 }}>
				Bitte planen Sie die Projektlaufzeit möglichst so, dass Ihr Projekt bis zum 31.12. umgesetzt werden kann.
			</Typography>
			<Typography>
				Projekte können, sofern ein Mittelabruf zum Jahresende erfolgt, 6 Monate bei Auslandsvorhaben bzw. 3 Monate bei Inlandsvorhaben in ein
				zweites Projektjahr gehen, ohne im zweiten Jahr Förderung zu beantragen.
			</Typography>
		</>
	);
};

export default ProjektDatenAntragEPZ;

const formStrucSpalte1 = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [P.Allgemein_Projekttitel, { ...P.Allgemein_Kurzwort, maxCharLength: 12 }],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};
const formStrucSpalte2 = (application: any) => {
	let struc: FormStrucItem[] = [
		{
			fields: [P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Projektdurchfuehrung],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
		{
			fields: [
				{ ...P.Allgemein_Geplante_Projektlaufzeit_von, ...getProjektLaufzeitVON_Validation(application) },
				{ ...P.Allgemein_Geplante_Projektlaufzeit_bis, ...getProjektLaufzeitBIS_Validation(application) },
			],
			userProps: { columnToDivide: 2 },
		},
	];
	return struc;
};

export const getFormStrucProjektDatenAntragEPZ = (application: any) => {
	let result: FormStrucItem[] = [];
	result = concat(formStrucSpalte1(), formStrucSpalte2(application));

	if (
		checkIfPruefAssitenzNeedsToValidate(application, P.Allgemein_Pruefung_Hinweis_Fuer_Den_Antragsteller.path, P.Allgemein_Pruefung_Erledigt.path)
	) {
		result = concat(formStrucProjektdatenPruefassistentGlobal(application), result);
	}
	return result;
};
